// Image resize and base64 utilities (keep existing utilities unchanged)
const resizeImage = (file, maxSizeKB = 100) => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    img.onload = () => {
      const maxWidth = 400;
      const maxHeight = 400;
      let { width, height } = img;

      if (width > height) {
        if (width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width = (width * maxHeight) / height;
          height = maxHeight;
        }
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);

      let quality = 0.9;
      let dataURL = canvas.toDataURL('image/jpeg', quality);

      const getBase64Size = (base64String) => {
        const stringLength = base64String.length - 'data:image/jpeg;base64,'.length;
        return Math.round(stringLength * 0.75);
      };

      while (getBase64Size(dataURL) > maxSizeKB * 1024 && quality > 0.1) {
        quality -= 0.1;
        dataURL = canvas.toDataURL('image/jpeg', quality);
      }

      resolve(dataURL);
    };

    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
};

const convertURLToBase64 = async (url) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    throw new Error('Failed to convert URL to base64');
  }
};

const getBase64Size = (base64String) => {
  const stringLength = base64String.length - 'data:image/jpeg;base64,'.length;
  return Math.round(stringLength * 0.75);
};

const isValidImageURL = (url) => {
  const imageExtensions = /\.(jpg|jpeg|png|gif|bmp|webp)(\?.*)?$/i;
  return imageExtensions.test(url);
};


export { resizeImage, convertURLToBase64, getBase64Size, isValidImageURL };
